var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.81909H4C2.89543 6.81909 2 7.72698 2 8.84693V12.9027C2 13.9661 2.80733 14.8383 3.83446 14.9237C3.88905 14.9282 3.94426 14.9305 4 14.9305L9 14.9304V6.81909Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1606 18.3703C17.5908 18.781 16.8148 18.8921 16.1056 18.5325L10.5 15.6907V6.0585L16.1056 3.2167C16.9367 2.79536 17.8596 3.02033 18.4348 3.61634C18.78 3.97396 19 4.46514 19 5.03044V16.7188C19 16.813 18.9939 16.9051 18.9821 16.995C18.9059 17.5759 18.5925 18.0591 18.1606 18.3703Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.8387C21.3626 12.6136 22 11.8196 22 10.8747C22 9.92984 21.3626 9.13589 20.5 8.91077V12.8387Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 16.4513C3.86041 16.4513 3.72271 16.443 3.58737 16.4269L3.19409 18.8194C3.0925 19.4374 3.56254 20 4.18048 20H6.15289C6.64173 20 7.05892 19.6417 7.13929 19.1528L7.58335 16.4513H4.00002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.d1a9f9da4302589bded4a52d42df8431.svg";
export { ForwardRef as ReactComponent };